// extracted by mini-css-extract-plugin
module.exports = {"grouping_count":"index_grouping_count_1sV81","right":"index_right__myhL"};